module.exports = __webpack_public_path__ + "img/icon-basket.f487fd89.svg";